import { render, staticRenderFns } from "./YearVoucherDetail.vue?vue&type=template&id=73d4505e&"
import script from "./YearVoucherDetail.vue?vue&type=script&lang=js&"
export * from "./YearVoucherDetail.vue?vue&type=script&lang=js&"
import style0 from "./YearVoucherDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports